module.exports = __webpack_public_path__ + "img/3.af9ff289.jpeg";